import { Facebook, Favorite, GitHub, Instagram, LinkedIn } from '@mui/icons-material';
import { Box, IconButton, ListItemButton, Stack, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { AdvancedImage } from '@cloudinary/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GLOBAL_CONSTANTS } from '@/utils/globalConstants';
import { AnchorLink } from '@/styles/commonStyles';
import colors from '@/styles/colors';
import { StyledCreditContainer, StyledImageContainer } from './styles';
import { getCloudinaryImage } from '@/utils/commonFunctions';

export default function RenderDrawerItem({ handleLinkClick }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    NAV_ITEMS,
    externalLinks: { github, fb, instagram, linkedin, reactJS },
  } = GLOBAL_CONSTANTS;

  const handleSelectedIndex = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight } = document.body;
      const docHeight = document.body.offsetHeight;
      const scrollPercent = scrollTop / (scrollHeight - docHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded === 0) {
        setActiveIndex(0);
      } else if (scrollPercentRounded > 0 && scrollPercentRounded <= 15) {
        setActiveIndex(1);
      } else if (scrollPercentRounded > 15 && scrollPercentRounded <= 40) {
        setActiveIndex(2);
      } else if (scrollPercentRounded > 40 && scrollPercentRounded <= 60) {
        setActiveIndex(3);
      } else if (scrollPercentRounded > 60 && scrollPercentRounded <= 80) {
        setActiveIndex(4);
      } else if (scrollPercentRounded > 80 && scrollPercentRounded <= 95) {
        setActiveIndex(5);
      } else {
        setActiveIndex(6);
      }
      document.querySelector(
        '#scroll',
      ).style.background = `linear-gradient(to right, ${colors.primary} ${scrollPercentRounded}%, transparent ${scrollPercentRounded}%)`;
    };
    document.body.addEventListener('scroll', handleScroll);
    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div style={{ height: "calc(100vh - 75px)" }}>
        <StyledImageContainer>
          <AnchorLink href={github}>
            <AdvancedImage cldImg={getCloudinaryImage('papu.jpg')} className="my__image" />
          </AnchorLink>
        </StyledImageContainer>
        <Box>
          <Stack spacing={2} direction="row" justifyContent="center">
            <AnchorLink href={github}>
              <IconButton edge="start" size="large">
                <GitHub htmlColor={colors.lighter} />
              </IconButton>
            </AnchorLink>
            <AnchorLink href={linkedin}>
              <IconButton edge="start" size="large">
                <LinkedIn htmlColor={colors.lighter} />
              </IconButton>
            </AnchorLink>
            <AnchorLink href={instagram}>
              <IconButton edge="start" size="large">
                <Instagram htmlColor={colors.lighter} />
              </IconButton>
            </AnchorLink>
            <AnchorLink href={fb}>
              <IconButton edge="start" size="large">
                <Facebook htmlColor={colors.lighter} />
              </IconButton>
            </AnchorLink>
          </Stack>
        </Box>
        <Divider />
        <Box sx={{ margin: '16px 0' }} />
        <List sx={{ padding: '8px 0' }}>
          {NAV_ITEMS.map(({ id, label, icon }, index) => (
            <ListItemButton
              key={id}
              onClick={() => {
                handleSelectedIndex(index);
                handleLinkClick(id);
              }}
              id={`link_${id}`}
              selected={index === activeIndex}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'rgb(191 199 206 / 30%)',
                },
                '&:hover': {
                  backgroundColor: 'rgb(191 199 206 / 30%)',
                },
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          ))}
        </List>
      </div>
      <StyledCreditContainer>
        <Typography component="span" sx={{ fontSize: '12px' }}>
          Made with <Favorite className="heart heart__anim" /> and <AnchorLink href={reactJS}>React</AnchorLink>
        </Typography>
      </StyledCreditContainer>
    </div>
  );
}

RenderDrawerItem.propTypes = {
  handleLinkClick: PropTypes.func.isRequired,
};
